import styled from '@emotion/styled';
import {
	AddressInput,
	CitySelectInput,
	CompanyNameInput,
	FirstNameInput,
	LastNameInput,
	PhoneNumberInput,
	PostalCodeInput,
	StateSelectInput,
	usePostalCodeData,
} from 'dw-au-react-components';
import React, { useEffect, useState } from 'react';
const StlyedBillingForm = styled.div`
	height: 0;
	overflow-x: hidden;
	transition: height 0.3s ease-in-out;
	&.show {
		height: auto;
		overflow-x: visible;
	}
`;

function BillingForm({
	register,
	errors,
	billingSameAsShipping,
	brandData,
	watch,
	setError,
	clearError,
	setValue,
	defaultValues,
}) {
	const watchedPostalCode = watch('postalCodeBilling');
	const watchedCityBilling = watch('cityBilling');
	const watchedStateBilling = watch('stateBilling');
	const [postalCode, setPostalCode] = useState('');
	const [cityList, setCityList] = useState([]);
	const [stateList, setStateList] = useState([]);
	const [addressFormError, setAddressFormError] = useState(false);

	useEffect(() => {
		if (watchedPostalCode) {
			setPostalCode(watchedPostalCode);
		}
	}, [watchedPostalCode]);

	let postalCodeData = usePostalCodeData(postalCode, brandData.country);

	const { finalPostalCode, finalCityList, finalStateList, error, isLoading } =
		postalCodeData;

	let invalidPostalCode =
		postalCode.length && error && finalPostalCode === false;

	useEffect(() => {
		if (!isLoading && invalidPostalCode) {
			setError(
				'postalCodeBilling',
				'isValidPostalCode',
				'Please enter a valid post code'
			);
			setAddressFormError('Please enter a valid post code');
			setCityList([]);
			setStateList([]);
			setValue('cityBilling', '');
			setValue('stateBilling', '');
		} else {
			clearError('postalCodeBilling');
			setAddressFormError(false);
		}
	}, [invalidPostalCode]);

	useEffect(() => {
		let cityOptions = '';
		if (finalPostalCode && finalCityList.length > 0) {
			cityOptions = finalCityList.map((city) => {
				return {
					option: city,
					value: city,
				};
			});
			setCityList(cityOptions);
			if (cityOptions.length === 1) {
				setValue('cityBilling', cityOptions[0].value);
			}
		}
	}, [finalCityList]);

	useEffect(() => {
		let stateOptions = '';
		if (finalPostalCode && finalStateList.length > 0) {
			stateOptions = finalStateList.map((city) => {
				return {
					option: city.stateCode,
					value: city.stateCode,
				};
			});
			setStateList(stateOptions);
			setValue('stateBilling', stateOptions[0].value);
			setValue('stateCodeBilling', stateOptions[0].value);
		}
	}, [finalStateList]);

	const clearValues = (element) => {
		setValue(element, '');
		clearError(element);
	};

	const handleDefaultValues = () => {
		Object.keys(defaultValues).map((key) => {
			setValue(key, defaultValues[key]);
			clearError(key);
		});
	};

	useEffect(() => {
		if (billingSameAsShipping === true) {
			clearValues('firstNameBilling');
			clearValues('lastNameBilling');
			clearValues('companyNameBilling');
			clearValues('phoneNumberBilling');
			clearValues('address1Billing');
			clearValues('address2Billing');
			clearValues('postalCodeBilling');
			clearValues('cityBilling');
			clearValues('stateBilling');
			clearValues('stateCodeBilling');
		} else if (billingSameAsShipping === false && defaultValues) {
			handleDefaultValues();
		}
	}, [billingSameAsShipping]);

	return (
		<StlyedBillingForm
			className={`billing__form ${!billingSameAsShipping ? 'show' : ''}`}
		>
			<div className='mb-16'>
				<FirstNameInput
					name='firstNameBilling'
					register={register}
					errors={errors}
					label='First Name*'
					placeholder='First Name*'
					required={!billingSameAsShipping}
				/>
			</div>
			<div className='mb-16'>
				<LastNameInput
					name='lastNameBilling'
					register={register}
					errors={errors}
					required={!billingSameAsShipping}
				/>
			</div>

			<div className='mb-16 d-none'>
				<CompanyNameInput
					name='companyNameBilling'
					register={register}
					required={!billingSameAsShipping}
				/>
			</div>

			<div className='mb-16'>
				<PhoneNumberInput
					name='phoneNumberBilling'
					register={register}
					errors={errors}
					required={!billingSameAsShipping}
					country={brandData.country}
				/>
			</div>

			<div className='mb-16'>
				<AddressInput
					name='Billing'
					register={register}
					errors={errors}
					country={brandData.country}
					required={!billingSameAsShipping}
				/>
			</div>

			{brandData.country !== 'NZ' && (
				<div className='mb-16'>
					<AddressInput
						name='Billing'
						type={2}
						required={false}
						register={register}
						errors={errors}
						country={brandData.country}
					/>
				</div>
			)}

			<div className='mb-16'>
				<PostalCodeInput
					name='postalCodeBilling'
					register={register}
					errors={errors}
					required={!billingSameAsShipping}
				/>
			</div>

			<div
				className={`${
					brandData.country !== 'NZ' ? 'd-flex justify-content-between' : ''
				}`}
			>
				<div className={`mb-16 ${brandData.country !== 'NZ' ? 'col-2' : ''}`}>
					<div className='section form-row'>
						<CitySelectInput
							name='cityBilling'
							register={register}
							errors={errors}
							cityList={cityList}
							setValue={setValue}
							clearError={clearError}
							defaultValue={watchedCityBilling}
							required={!billingSameAsShipping}
						/>
					</div>
				</div>

				<div className={`mb-16 ${brandData.country !== 'NZ' ? 'col-2' : ''}`}>
					{brandData.country !== 'NZ' ? (
						<div className='section form-row'>
							<StateSelectInput
								name='stateBilling'
								register={register}
								errors={errors}
								stateList={stateList}
								setValue={setValue}
								clearError={clearError}
								defaultValue={watchedStateBilling}
								required={!billingSameAsShipping}
							/>
							<input
								type='hidden'
								name='stateCodeBilling'
								/* eslint-disable react/no-unknown-property */
								register={register({ name: 'stateCodeBilling' })}
							/>
						</div>
					) : null}
				</div>
			</div>
			{addressFormError && (
				<div className='mt-20 alert alert-danger'>{addressFormError}</div>
			)}
		</StlyedBillingForm>
	);
}

export default BillingForm;
